import hoverintent from 'hoverintent'

function setupTooltip(el, binding) {
  if (!binding.value) {
    return
  }

  $(el)
    .attr('data-toggle', 'tooltip')
    .attr('data-html', 'true')
    .attr('data-placement', binding.arg)
    .attr('title', binding.value)
    .attr('data-container', 'body')
    .tooltip({
      title: binding.value,
      trigger: 'manual',
    })

  el.hoverIntent = hoverintent(
    el,
    () => {
      $(el).tooltip('show')
    },
    () => {
      $(el).tooltip('hide')
    },
  )
  $(el).on('click', () => {
    $(this).tooltip('hide')
  })
}

function teardownTooltip(el) {
  $(el).tooltip('destroy')
  if (el.hoverIntent) {
    el.hoverIntent.remove()
    el.hoverIntent = null
  }
}

export function loadVueDirectives(app) {
  app.directive('tooltip', {
    beforeMount(el, binding) {
      setupTooltip(el, binding)
    },
    updated(el, binding) {
      if (binding.value === binding.oldValue) {
        return
      }
      teardownTooltip(el)
      setupTooltip(el, binding)
    },
    unmounted(el) {
      teardownTooltip(el)
    },
  })

  // Found here https://stackoverflow.com/questions/36170425/detect-click-outside-element
  app.directive('click-outside', {
    beforeMount(el, binding) {
      el.event = (event) => {
        // here I check that click was outside the el and its children's
        if (!(el === event.target || el.contains(event.target))) {
          // and if it did, call method provided in attribute value
          binding.value(event)
        }
      }
      document.body.addEventListener('click', el.event, true)
    },
    unmounted(el) {
      document.body.removeEventListener('click', el.event)
    },
  })

  app.directive('hover-intent', {
    beforeMount(el, binding) {
      el.hoverIntent = hoverintent(el, binding.value.in, binding.value.out)
      el.hoverIntent.options({ ...el.opts })
    },
    unmounted(el) {
      el.hoverIntent?.remove()
    },
  })
}
